import { render, staticRenderFns } from "./CNICPromoDashboardComponent.vue?vue&type=template&id=50ebc1f1"
import script from "./CNICPromoDashboardComponent.vue?vue&type=script&lang=js"
export * from "./CNICPromoDashboardComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports